import Reflux from 'reflux';
import { actions } from 'actions';
var SupplierAttributeStore = Reflux.createStore({
  init: function() {
    this.listenTo(actions.getSupplierAttribute, this.getAttribute);
    this.listenTo(actions.saveSupplierAttribute, this.saveAttribute);
  },
  getAttribute: function(supplierId, attributeType) {
    fetch('/rest/v2/supplier/'+supplierId + '/attribute/' + attributeType).then((response) => {
      return response.json();
    }).then(data => {
      data['attributeKey'] = attributeType;
      this.trigger(data);
    });
  },
  saveAttribute: function(supplierId, attributeType, fields) {
    fetch('/rest/v2/supplier/'+supplierId + '/attribute/'+attributeType, {
      method: 'POST',
      body: JSON.stringify(fields),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      return response.json();
    }).then(data => {
      data['attributeKey'] = attributeType;
      data['value'] = data.value ? data.value : fields?.value
      this.trigger(data);
    });
  }
})
export { SupplierAttributeStore };
